export default {
  TASKS_MODAL_OPEN: 'tasks-modal:open',
  TASKS_MODAL_CLOSE: 'tasks-modal:close',
  TASKS_MODAL_EDIT_OPEN: 'vue-tasks-modal-edit:open',
  TASKS_MODAL_EDIT_CLOSE: 'vue-tasks-modal-edit:close',
  TASKS_MODAL_OPEN_EDIT: 'tasks-modal:edit',
  TASKS_MODAL_DUPLICATE: 'tasks-modal:duplicate',
  FETCH_LM_RULES: 'schedule:labor-model-rules:fetch',
};
